import {
  ScheduledNotificationCommunicationType,
} from '@shared/enums/ScheduledNotificationType';
import { useTranslation } from 'react-i18next';

export const useNotificationCommunicationTypeLabel = (): Record<
  ScheduledNotificationCommunicationType,
  string
> => {
  const { t } = useTranslation();
  return {
    [ScheduledNotificationCommunicationType.Insights]:
      t(($) => $.notificationBuilder.communicationTypes.insights),
    [ScheduledNotificationCommunicationType.PointsExpiration]:
      t(($) => $.notificationBuilder.communicationTypes.pointsExpiration),
    [ScheduledNotificationCommunicationType.ProgramRollover]:
      t(($) => $.notificationBuilder.communicationTypes.programRollover),
    [ScheduledNotificationCommunicationType.Promotions]:
      t(($) => $.notificationBuilder.communicationTypes.promotions),
    [ScheduledNotificationCommunicationType.ReachNextTier]:
      t(($) => $.notificationBuilder.communicationTypes.reachNextTier),
    [ScheduledNotificationCommunicationType.ReEarnYourStatus]:
      t(($) => $.notificationBuilder.communicationTypes.reEarnYourStatus),
    [ScheduledNotificationCommunicationType.RewardsProgram]:
      t(($) => $.notificationBuilder.communicationTypes.rewardsProgram),
    [ScheduledNotificationCommunicationType.UsingPoints]:
      t(($) => $.notificationBuilder.communicationTypes.usingPoints),
  };
};
